import { render, staticRenderFns } from "./ExchangeEmployeesListing.vue?vue&type=template&id=245fa545&scoped=true"
import script from "./ExchangeEmployeesListing.vue?vue&type=script&lang=js"
export * from "./ExchangeEmployeesListing.vue?vue&type=script&lang=js"
import style0 from "./ExchangeEmployeesListing.vue?vue&type=style&index=0&id=245fa545&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245fa545",
  null
  
)

export default component.exports